import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Table,
  Tr,
  Td,
  Tbody,
  Th,
  Thead,
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export class objInvoices {
  constructor(invoice_id, invoice_number, invoice_date) {
    var d = invoice_date.split("-");
    invoice_date = d[2] + "/" + d[1] + "/" + d[0];

    var invoice_date_min = d[2] + "-" + d[1] + "-" + d[0];
    this.invoice_id = invoice_id;
    this.invoice_number = invoice_number;
    this.invoice_date = invoice_date;
    this.invoice_date_min = invoice_date_min;
    this.lstPayments = [];
    this.lstRefunds = [];
    this.lstClients = [];
    this.lstItems = [];
    this.total = 0;
    this.foundCredit = false;
  }

  addItem(item){
    let qun = Number(item["item_quantity"]);
    this.lstItems.push(item);
    this.total += item["item_unit_price"] * qun;
  }
}

export class objPayment {
  constructor(
    payment_id,
    payment_type,
    payment_amount,
    payment_date,
    payment_by,
    payment_reference
  ) {
    this.payment_id = payment_id;
    this.payment_type = payment_type;
    this.payment_amount = payment_amount;
    this.payment_date = payment_date;
    this.payment_by = payment_by;
    this.payment_reference = payment_reference;
  }
}

export class objRefund {
  constructor(
    refund_id,
    refund_reason,
    refund_amount,
    refund_record_time,
    refund_record_by,
    account_id,
    refund_penalty_amount
  ) {
    this.refund_id = refund_id;
    this.refund_reason = refund_reason;
    this.refund_amount = refund_amount;
    this.refund_record_time = refund_record_time;
    this.refund_record_by = refund_record_by;
    this.account_id = account_id;
    this.refund_penalty_amount = refund_penalty_amount;
  }
}

export class objClient {
  constructor(
    book_id,
    intake_id,
    client_id,
    book_payment_status,
    book_by_staff
  ) {
    this.book_id = book_id;
    this.intake_id = intake_id;
    this.client_id = client_id;
    this.book_payment_status = book_payment_status;
    this.book_by_staff = book_by_staff;
  }
}

export class objCourse {
  constructor(campusid, courseid, intakeid, start, end, enrolled, capacity) {
    this.campusid = campusid;
    this.coursename = "";
    this.courseid = courseid;
    this.intakeid = intakeid;
    this.start = start;
    this.end = end;

    this.startDate = "";
    this.endDate = "";

    this.startDay = "";
    this.startMonth = "";
    this.startYear = "";

    if (start.includes("-")) {
      var s = start.split("-");
      this.startDate = s[2] + "/" + s[1] + "/" + s[0];
      this.startDay = s[2];
      this.startMonth = s[1];
      this.startYear = s[0];
    }

    if (end.includes("-")) {
      var s = end.split("-");
      this.endDate = s[2] + "/" + s[1] + "/" + s[0];
    }

    //this.status = enrolled + "/" + capacity;
    this.capacity = capacity;
    this.enrolled = enrolled;

    if (!isNumeric(this.enrolled)) {
      this.enrolled = 0;
    }

    this.campus = "";
    this.campusid = "";
  }
}

export class objWindowCourseCalendar {
  constructor() {
    this.timeStampId = "";
    this.lstCourses = [];
  }
}

export class objMagicTable {
  constructor(data, hide, show) {
    this.data = data;
    this.hide = hide;
    this.show = show;
    /*if(show == undefined){
      show = [];
    }
    if(hide == undefined){
      hide = [];
    }
    if(data.length > 0){
      var lstTitles = Object.keys(data[0]);
      this.lstData = [];
      //this.titles = lstTitles;
      if(show.length > 0){
        this.titles = show;
      }


      var tmpTitles = [];
      for(var s in lstTitles){
        if(!hide.includes(lstTitles[s])){
          tmpTitles.push(lstTitles[s]);
        }
        this.titles = tmpTitles;
      }

      for(var d in data){
        var lstRow = [];
        for(var t in lstTitles){
          if(!hide.includes(lstTitles[t]) && show.length == 0){
            lstRow.push(data[d][lstTitles[t]]);
          }else{
            if(show.includes(lstTitles[t])){
              lstRow.push(data[d][lstTitles[t]]);
            }
          }
        }
        this.lstData.push(lstRow);
      }
    }*/
  }

  getChakraTbl(lstTitles, lstData) {
    if (lstTitles && lstData) {
      if (lstTitles.length > 0 && lstData.length > 0) {
        var titles = lstTitles.map((t) => <Th key={uuidv4()}>{t}</Th>);

        var lstBody = [];

        for (var d in lstData) {
          var body = lstData[d].map((r) => <Td key={uuidv4()}>{r}</Td>);
          lstBody.push(<Tr>{body}</Tr>);
        }

        var tbl = (
          <Table size="sm" variant="striped" colorScheme="teal">
            <Thead>
              <Tr>{titles}</Tr>
            </Thead>
            <Tbody>{lstBody}</Tbody>
          </Table>
        );
        return tbl;
      }
    }

    return <>empty</>;
  }

  getHtmlTbl(lstTitles, lstData) {
    var titles = lstTitles.map((t) => <th key={uuidv4()}>{t}</th>);

    var lstBody = [];

    for (var d in lstData) {
      var body = lstData[d].map((r) => <td key={uuidv4()}>{r}</td>);
      lstBody.push(<tr>{body}</tr>);
    }

    var tbl = (
      <table size="sm" variant="striped" colorScheme="teal">
        <thead>
          <tr>{titles}</tr>
        </thead>
        <tbody>{lstBody}</tbody>
      </table>
    );
    return tbl;
  }

  getChakraAllTbl(lstTitles, lstData) {
    var titles = lstTitles.map((t) => <Th key={uuidv4()}>{t}</Th>);

    var lstBody = [];

    for (var d in lstData) {
      var body = lstData[d].map((r) => <Td key={uuidv4()}>{r}</Td>);
      lstBody.push(<Tr>{body}</Tr>);
    }

    var tbl = (
      <Table size="sm" variant="striped" colorScheme="teal">
        <Thead>
          <Tr>{titles}</Tr>
        </Thead>
        <Tbody>{lstBody}</Tbody>
      </Table>
    );
    return tbl;
  }

  getStrictTable(type) {
    var lstTitles = [];
    var lstData = [];
    if (this.data.length > 0) {
      var tmplstTitles = Object.keys(this.data[0]);
      for (var t in tmplstTitles) {
        if (this.show.includes(tmplstTitles[t])) {
          lstTitles.push(tmplstTitles[t]);
        }
      }
    }

    for (var d in this.data) {
      var lstRow = [];
      for (var t in lstTitles) {
        lstRow.push(this.data[d][lstTitles[t]]);
      }
      lstData.push(lstRow);
    }
    if (type == "chakra") {
      return this.getChakraTbl(lstTitles, lstData);
    } else {
      return this.getHtmlTbl(lstTitles, lstData);
    }
  }

  getChakraTable() {
    var lstTitles = [];
    var lstData = [];
    if (this.data.length > 0) {
      lstTitles = Object.keys(this.data[0]);
    }

    for (var d in this.data) {
      var lstRow = [];
      for (var t in lstTitles) {
        lstRow.push(this.data[d][lstTitles[t]]);
      }
      lstData.push(lstRow);
    }

    var titles = lstTitles.map((t) => <Th key={uuidv4()}>{t}</Th>);

    var lstBody = [];

    for (var d in lstData) {
      var body = lstData[d].map((r) => <Td key={uuidv4()}>{r}</Td>);
      lstBody.push(<Tr>{body}</Tr>);
    }

    var tbl = (
      <Table size="sm" variant="striped" colorScheme="teal">
        <Thead>
          <Tr>{titles}</Tr>
        </Thead>
        <Tbody>{lstBody}</Tbody>
      </Table>
    );
    return tbl;
  }
}

/*module.exports = {
  objWindowCourseCalendar,
  objCourse,
};
*/
